import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
import ModuleQuestion from "../../components/ModuleQuestion";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_2_1_1 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section>
            <h1 className="blue text-uppercase b mt-5 mb-4">
              2.4.5 Practice Case 3
            </h1>
            <p className="me-4">Estimated time to complete: 5 minutes</p>
          </section>
          <ModuleQuestion
            correctAnswer="A"
            assessmentName="practice_case_3"
            videoTranscript={
              <>
                <p>
                  <strong>AUDIO</strong>
                  <br />
                  VO: (FEMALE)
                  <br />
                </p>
                <p>
                  This is Practice Case Number 3. This is a positive case. When
                  you loaded this case, you may have noticed that there was no
                  CT. This is because the scan was collected on a PET-only
                  machine. The size and contrast have already been adjusted.
                  Starting at the bottom of the brain and moving superiorly, we
                  enter into the cerebellum, where normal gray-white contrast
                  can be seen throughout. Again moving superiorly, we enter into
                  the temporal and occipital regions. It is immediately clear
                  that there is loss of gray-white contrast throughout both
                  lobes, on both sides. In addition, white matter tracts are not
                  clearly identifiable on either side. Although small areas of
                  white matter tracts may be seen, overall, there is loss of
                  gray-white contrast. Therefore, the temporal and occipital
                  lobes are clearly positive. As we move superiorly and enter
                  into the prefrontal cortices, the effects of noise and atrophy
                  make evaluation of this region difficult. However, small areas
                  of preserved white matter tracts may be seen here and here, as
                  well as here. Overall, though, there remains loss of
                  gray-white contrast over here and over here. This loss of
                  gray-white contrast is also seen posteriorly as we enter into
                  the parietal region. In this region, there is loss of
                  gray-white contrast. This pattern is also seen here, and again
                  over here. Overall, the loss of gray-white contrast persists
                  as we move to the top of the brain. In addition, white matter
                  tracts are not clearly identifiable, coursing from the front
                  of the brain posteriorly. Again, there is loss of gray-white
                  contrast throughout the top of the brain. So, in review, there
                  is clear loss of gray-white contrast in the temporal,
                  occipital, and parietal lobes, and, to a lesser degree, in the
                  frontal cortices. Therefore, this case is positive for
                  moderate to frequent neuritic plaques.
                </p>
              </>
            }
            previousLesson="/module-2/module-2-4-4"
            nextLesson="/module-2/module-2-4-6"
            iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_1468313807&entry_id=1_13jdjzpv&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
            questionType="practice"
            videoId="1_13jdjzpv"
          />
        </main>
      </div>
    </div>
  );
};

export default Module_2_1_1;
